import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const CheckCircleOutlineIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg fill="none" height={size} viewBox="0 0 25 24" width={size}>
    <path
      d="M8.90121 12L11.0284 14.1111L15.2829 9.88889M21.6646 12C21.6646 17.2467 17.3788 21.5 12.0921 21.5C6.80529 21.5 2.51953 17.2467 2.51953 12C2.51953 6.75329 6.80529 2.5 12.0921 2.5C17.3788 2.5 21.6646 6.75329 21.6646 12Z"
      stroke={color}
      strokeWidth="2.11111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
